export const italiano = {
    anagrafiche: {
        titolo: 'Personalizza sedi',
        sottotitolo: 'Modifica la dicitura delle sedi'
    },
    ubicazioni: {
        titolo: 'Modifica ubicazione',
        sottotitolo: "Aggiorna l'ubicazione della matricola",
    }
}

export const inglese = {
    anagrafiche: {
        titolo: 'Personalizza sedi',
        sottotitolo: 'Modifica la dicitura delle sedi'
    },
    ubicazioni: {
        titolo: 'Modifica ubicazione',
        sottotitolo: "Aggiorna l'ubicazione della matricola",
    }
}